// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cancel-btn[data-v-96aece92] {\n    background-color: #94BEC1;\n    border-color: #94BEC1;\n    width: 167px;\n    height: 42px;\n    font-size: 16px;\n    font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
